<template>
  <el-table-column :label="label" :prop="prop" class-name="paid-cargo-volume" :sortable="sortable">
    <template slot-scope="scope">
      {{scope.row.paid_cargo_volume.toLocaleString()}}
    </template>
  </el-table-column>
</template>

<script>
export default {
  components: {
  },
  props: {
    label: {
      type: String,
      default: '有償貨物量'
    },
    prop: {
      type: String,
      default: 'paid_cargo_volume'
    },
    sortable: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss">
.el-table {
  td,
  th {
    &.paid-cargo-volume {
      width: 10em;
    }
  }
  td.paid-cargo-volume {
    text-align: right;
  }
}
</style>
